(() => {
  function rulesEl() {
    return document.querySelector('script[id^="VariantRules-"]');
  }

  function getRulesMap() {
    const el = rulesEl();
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  function findProductForm() {
    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    const addToCartForm = forms.find(f => f.querySelector('button[name="add"], input[name="add"]'));
    return addToCartForm || null;
  }

  function getSelectedVariantId(form) {
    const idInput = form.querySelector('input[name="id"]');
    return idInput ? idInput.value : null;
  }

  function getQtyInput(form) {
    return (
      form.querySelector('input.quantity__input') ||
      form.querySelector('input[name="quantity"]') ||
      document.querySelector('input.quantity__input') ||
      document.querySelector('input[name="quantity"]')
    );
  }
// ---------------------------
// COLOR pills for "Colore"
// ---------------------------
const SWATCH_BY_COLORE = {
  "Bianco": "#ffffff",
  "Crema": "#f3e6d0",
  "Kraft": "#c8a165",
  "Rosa Cipria": "#e7b7b3",
  "Verde Salvia": "#9caf9a",
  "Blu": "#2f5aa8",
  "Carta da Zucchero": "#9fbfd7",
  "Rosso": "#c43a3a",
  "Nero": "#111111"
};

// ritorna true se il colore è "chiaro" -> testo scuro
function isLightHex(hex) {
  const h = (hex || "").replace("#", "").trim();
  if (h.length !== 6) return true;
  const r = parseInt(h.slice(0,2), 16);
  const g = parseInt(h.slice(2,4), 16);
  const b = parseInt(h.slice(4,6), 16);
  // luminanza percepita
  const luminance = (0.299*r + 0.587*g + 0.114*b) / 255;
  return luminance > 0.72;
}

function applyColorPills() {
  // trova il fieldset "Colore"
  const fieldsets = document.querySelectorAll('variant-radios fieldset');
  let fsColore = null;

  for (const fs of fieldsets) {
    const legend = fs.querySelector('legend')?.textContent?.trim();
    if (legend === "Colore") { fsColore = fs; break; }
  }
  if (!fsColore) return;

  fsColore.classList.add("scatoledieffe-color-pills");

  // ogni input radio ha un label subito dopo (Dawn)
  const radios = fsColore.querySelectorAll('input[type="radio"]');
  radios.forEach(radio => {
    const value = (radio.value || "").trim();
    const hex = SWATCH_BY_COLORE[value];
    if (!hex) return;

    const label = radio.nextElementSibling;
    if (!label) return;

    const light = isLightHex(hex);
    label.style.setProperty("--swatch-bg", hex);
    label.style.setProperty("--swatch-fg", light ? "#3b2a23" : "#ffffff");

    // aiuta CSS per i colori chiari (bianco/crema)
    label.dataset.swatch = light ? "light" : "dark";
  });
}

  function getMinForVariant(rulesMap, variantId) {
    const rule = rulesMap?.[variantId];
    const minQty = rule?.minQty ?? 1;
    return { rule, minQty };
  }

  // ---------------------------
  // TEXTBOX rules (by option)
  // ---------------------------

  const PERSONALIZZAZIONE_OFF = "Senza stampa";

  // ⚠️ Metti qui i NOMI ESATTI delle 2 personalizzazioni (come li vedi sul sito)
  const TEXT_BY_PERSONALIZZAZIONE = {
    "Stampa a caldo": "Inserisci i dettagli per la personalizzazione ( + 75,00 € ):",
    "Stampa digitale": "Inserisci i dettagli per la personalizzazione:"
  };

  function getTextboxUI() {
    const wrap = document.querySelector('[data-scatoledieffe-textbox]');
    if (!wrap) return null;
    return {
      wrap,
      label: wrap.querySelector('[data-scatoledieffe-textbox-label]'),
      textarea: wrap.querySelector('textarea')
    };
  }

  function getSelectedOptionValue(optionName) {
    const fieldsets = document.querySelectorAll('variant-radios fieldset');
    for (const fs of fieldsets) {
      const legend = fs.querySelector('legend')?.textContent?.trim();
      if (legend && legend.toLowerCase() === optionName.toLowerCase()) {
        return fs.querySelector('input[type="radio"]:checked')?.value?.trim() || "";
      }
    }
    return "";
  }

  function applyTextboxByPersonalizzazione() {
    const ui = getTextboxUI();
    if (!ui) return;

    const selected = getSelectedOptionValue("Personalizzazione");
    const enabled = !!selected && selected.toLowerCase() !== PERSONALIZZAZIONE_OFF.toLowerCase();

    ui.wrap.style.display = enabled ? "" : "none";

    if (ui.textarea) {
      ui.textarea.required = enabled;
      if (!enabled) ui.textarea.value = "";
    }

    if (!enabled) return;

    const title = TEXT_BY_PERSONALIZZAZIONE[selected] || `Inserisci i dettagli per: ${selected}*`;
    if (ui.label) ui.label.textContent = title;
  }

  // ---------------------------
  // MIN QTY
  // ---------------------------

  function enforceMinQty(form, rulesMap) {
    const variantId = getSelectedVariantId(form);
    if (!variantId) return;

    const { minQty } = getMinForVariant(rulesMap, variantId);

    const qtyInput = getQtyInput(form);
    if (qtyInput) {
      qtyInput.min = String(minQty);

      const current = parseInt(qtyInput.value || '1', 10);
      if (!Number.isFinite(current) || current < minQty) {
        qtyInput.value = String(minQty);
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const label = document.querySelector('[data-min-qty-label]');
    if (label) label.textContent = String(minQty);

    // update textbox each time options/variants move
    applyTextboxByPersonalizzazione();
  }

  async function addItems(items) {
    const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }

  document.addEventListener('DOMContentLoaded', () => {
    const rulesMap = getRulesMap();
    if (!rulesMap) return;

    const form = findProductForm();
    if (!form) return;

    // init
    enforceMinQty(form, rulesMap);
    applyTextboxByPersonalizzazione();
    applyColorPills();

    applyColorPills();
    document.addEventListener('change', applyColorPills);

    // clamp continuo
    const interval = setInterval(() => enforceMinQty(form, rulesMap), 150);
    window.addEventListener('pagehide', () => clearInterval(interval));

    // on any option change
    document.addEventListener('change', applyTextboxByPersonalizzazione);

    // submit addon
    form.addEventListener('submit', async (e) => {
      const variantId = getSelectedVariantId(form);
      if (!variantId) return;

      const { rule, minQty } = getMinForVariant(rulesMap, variantId);
      const addonVariantId = rule?.addonVariantId ? String(rule.addonVariantId).trim() : '';

      if (!addonVariantId) return; // normal theme submit

      // validate textbox (because we prevent default)
      const ui = getTextboxUI();
      if (ui?.textarea?.required && !ui.textarea.value.trim()) {
        ui.textarea.focus();
        ui.textarea.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const qtyInput = getQtyInput(form);
      let qty = parseInt(qtyInput?.value || String(minQty), 10);
      if (!Number.isFinite(qty) || qty < minQty) qty = minQty;

      try {
        await addItems([
          { id: Number(variantId), quantity: qty },
          { id: Number(addonVariantId), quantity: 1 }
        ]);
        window.location.href = `${window.Shopify.routes.root}cart`;
      } catch (err) {
        console.error(err);
        alert('Errore: addon non aggiunto. Controlla che la variante addon sia acquistabile (disponibile/inventario).');
      }
    }, true);
  });

  // Expose for quick console checks
  window.applyTextboxByPersonalizzazione = applyTextboxByPersonalizzazione;
})();
